import { render, staticRenderFns } from "./NewEventRow.vue?vue&type=template&id=2d617e27"
import script from "./NewEventRow.vue?vue&type=script&lang=js"
export * from "./NewEventRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports